export const tel = [
  {
    path: '/tel/service',
    name: 'TelService',
    component: resolve => require(['@pages/main/tel/Service'], resolve),
    meta: {auth: true}
  },
  {
    path: '/tel/service/:id',
    name: 'TelServiceDetail',
    component: resolve => require(['@pages/main/tel/Service/Detail'], resolve),
    meta: {auth: true}
  },
  {
    path: '/tel/service/:id/edit',
    name: 'TelServiceEdit',
    component: resolve => require(['@pages/main/tel/Service/Edit'], resolve),
    meta: {auth: true}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/tel.route.js